export default __webpack_public_path__ + "static/media/40.91eaf87d.jpg";